import React from 'react'
import styled from 'styled-components'
import {combineDateAndTimeStrings, formatTime} from '../../utils/time'
import {_L, useLocaleState} from '../../context/LocaleContext'

const MeetingRoomInfo = ({room, reservations}) => {
  const localeState = useLocaleState()
  const untilText = _L({key: 'until', localeState})
  const reservedText = _L({key: 'Reserved', localeState})
  const availableText = _L({key: 'Available', localeState})

  let roomStatus = availableText

  const now = new Date().getTime()

  let reservationDates = reservations.reduce((acc, reservation) => {
    const {
      reserveDateStart,
      reserveTimeStart,
      reserveDateEnd,
      reserveTimeEnd
    } = reservation
    let reservationStart = combineDateAndTimeStrings(
      reserveDateStart,
      reserveTimeStart
    )
    let reservationEnd = combineDateAndTimeStrings(
      reserveDateEnd,
      reserveTimeEnd
    )

    acc.push({
      start: reservationStart.getTime(),
      end: reservationEnd.getTime()
    })

    return acc
  }, [])

  // Remove equal adjacent elements

  let sequence = reservationDates.reduce((acc, item, idx) => {
    if (idx === 0) {
      acc.push(item)
    } else {
      let index = acc.length - 1
      if (acc[index].end === item.start) {
        acc[index].end = item.end
      } else {
        acc.push(item)
      }
    }
    return acc
  }, [])

  if (sequence.length > 0) {
    const {start, end} = sequence[0]

    // If the current time is contained in the first interval then the room is reserved
    if (now > start && now < end) {
      roomStatus = `${reservedText} ${untilText} ${formatTime(
        new Date(end),
        'LT'
      )}`
    } else {
      roomStatus = `${availableText} ${untilText} ${formatTime(
        new Date(start),
        'LT'
      )}`
    }
  }

  const {rmId, name} = room
  const roomName = name ? ` - ${name}` : ''
  const roomTitle = rmId + roomName

  return (
    <Container>
      <StyledRoomInfo>{roomTitle}</StyledRoomInfo>
      <RoomReservationInfo>{roomStatus}</RoomReservationInfo>
    </Container>
  )
}

export default MeetingRoomInfo

const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const StyledRoomInfo = styled.div`
  color: white;
  font-size: 36px;
  
  @media (max-width: 420px) {
    font-size: 24px;
  }
`

const RoomReservationInfo = styled.div`
  color: #7b7e8a;
  font-size: 20px;
  
  @media (max-width: 420px) {
    font-size: 14px;
  }
`
